import { render, staticRenderFns } from "./all-players.vue?vue&type=template&id=a2e52578&"
import script from "./all-players.vue?vue&type=script&lang=js&"
export * from "./all-players.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports